import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

// import { CustomFormsModule } from 'ngx-custom-validators';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

/* Local components */
import { BeachtennisComponent } from './beachtennis.component';
import { BeachtennisHomeComponent } from './components/home/beachtennis-home.component';
import { BeachtennisAttachedComponent } from './components/attached/beachtennis-attached.component';
import { BeachtennisRankingComponent } from './components/ranking/list/beachtennis-ranking.component';
import { BeachtennisRankingClassifComponent } from './components/ranking/classification/beachtennis-ranking-classif.component';
import { BeachtennisRankingHistoryComponent } from './components/history/beachtennis-ranking-history.component';

/* Routes */
import { BeachtennisRoutingModule } from './beachtennis-routing.module';

/* Interceptor */
import { Interceptor } from 'src/app/core/interceptors/http-request-interceptor';
import { ThemeModule } from 'src/app/@theme/theme.module';

@NgModule({
    declarations: [
        BeachtennisComponent,
        BeachtennisHomeComponent,
        BeachtennisAttachedComponent,
        BeachtennisRankingComponent,
        BeachtennisRankingClassifComponent,
        BeachtennisRankingHistoryComponent,
    ],
    imports: [CommonModule, RouterModule, BeachtennisRoutingModule, ThemeModule, Interceptor],
})
export class BeachtennisModule {}
